import { render, staticRenderFns } from "./sjtb.vue?vue&type=template&id=5f9bcf51&scoped=true&"
import script from "./sjtb.vue?vue&type=script&lang=js&"
export * from "./sjtb.vue?vue&type=script&lang=js&"
import style0 from "./sjtb.vue?vue&type=style&index=0&id=5f9bcf51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9bcf51",
  null
  
)

export default component.exports